import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface NotificationMailTemplate {
  id: number
  subject: string
  body: string
  date: string
  placeCode: SystemCode
  revision: number
}

export function NotificationMailTemplateFromJSON(
  json: any
): NotificationMailTemplate {
  return {
    id: exists(json, 'id') ? json.id : 0,
    subject: exists(json, 'subject') ? json.subject : '',
    body: exists(json, 'body') ? json.body : '',
    date: exists(json, 'date') ? dateToPlainFormat(json.date) : '',
    placeCode: exists(json, 'place_code')
      ? SystemCodeFromJSON(json.place_code)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
